import { jsxs as o, jsx as l } from "react/jsx-runtime";
const t = (r) => /* @__PURE__ */ o(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    ...r,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M49.942 48h-36V28.648h36V48l4-1.072V32H58V12H10a4 4 0 0 0-4 4v12.058A3.942 3.942 0 0 0 9.942 32v16a4 4 0 0 0 4 4h37.072l-1.072-4ZM10 26.648V16h44v10.648H10Z"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m34.12 34.051-5.795 1.553 1.553 5.796 5.796-1.553-1.553-5.796Z"
        }
      )
    ]
  }
);
export {
  t as Archive
};
